import { createRequestActions } from '../utils';
import * as processTypes from './processTypes';

export const process = createRequestActions(processTypes.PROCESS);
export const saveProcess = createRequestActions(processTypes.SAVE_PROCESS, data => data);
export const deleteProcess = createRequestActions(processTypes.DELETE_PROCESS, data => data);
export const addProcess = createRequestActions(processTypes.ADD_PROCESS, data => data);
export const addMultipleProcesses = createRequestActions(processTypes.ADD_MULTIPLE_PROCESSES, data => data);
